 // React Component (or JSX)

 import React from 'react';
 import './App.css'; // Assuming you have a CSS file for styles
 
 const Bishal_Santra_BlogPosts = () => {
   return (
        <>
        <ul className="bishal-santra-post-list" 
        style={{ marginTop: 0, paddingTop: 0 }}
        // style={{ 
        //   // display: 'flex', 
        //   justifyContent: 'center' }}
          >
            <li>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span className="bishal-santra-post-meta">Aug 12, 2023</span>
              <h3>
                <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/blog/2023/08/12/llm-channel-method-flaw.html">
                  Explaining Issues with Channel Method in LLM Prompt-based Classification
                </a>
              </h3>
              </div>
            </li>
            <li>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span className="bishal-santra-post-meta">Feb 11, 2023</span>
              <h3>
                <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/blog/2023/02/11/2022-02-11-algebraic-numbers-countable-proof.html">
                  Prove that the set of algebraic numbers are countable (using primes)
                </a>
              </h3>
              </div>
            </li>
            <li>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span className="bishal-santra-post-meta">Feb 10, 2023</span>
              <h3>
                <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/blog/2023/02/10/2023-02-10-sum-1-by-n-divergent.html">
                  Is ∑<sub>i=1</sub><sup>n</sup> 1/n divergent?
                </a>
              </h3>
              </div>
            </li>
            <li>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span className="bishal-santra-post-meta">Oct 7, 2021</span>
              <h3>
                <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2021/10/07/how-to-ssh-jump-cnerg.html">
                  How to Connect through an SSH Jump Server (For CNeRG project students)
                </a>
              </h3>
              </div>
            </li>
            <li>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span className="bishal-santra-post-meta">Oct 26, 2019</span>
              <h3>
                <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2019/10/26/transformer-language-models-and-pretraining.html">
                  Transformer Language Models and Pretraining
                </a>
              </h3>
              </div>
            </li>
            <li>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span className="bishal-santra-post-meta">Aug 31, 2019</span>
              <h3>
                <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2019/08/31/english-to-hindi-transliteration-using-seq2seq-model.html">
                  English to Hindi Transliteration using Seq2Seq Model
                </a>
              </h3>
              </div>
            </li>
            <li>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span className="bishal-santra-post-meta">Aug 31, 2019</span>
              <h3>
                <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2019/08/31/deep-sentiment-analysis.html">
                  Deep Sentiment Analysis
                </a>
              </h3>
              </div>
            </li>
            <li>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span className="bishal-santra-post-meta">Jul 13, 2019</span>
              <h3>
                <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/2019/07/13/text-classification-using-naive-bayes-method.html">
                  Text Classification using Naive Bayes Method
                </a>
              </h3>
              </div>
            </li>
            <li>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span className="bishal-santra-post-meta">Jul 8, 2019</span>
              <h3>
                <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2019/07/08/training-xtra-small-transformer-language-model.html">
                  Training a Language Model with a Xtra-Small Transformer (Transformer-XS)
                </a>
              </h3>
              </div>
            </li>
            <li>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span className="bishal-santra-post-meta">Jul 7, 2019</span>
              <h3>
                <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2019/07/07/simple-reddit-dialogue-preprocessor.html">
                  Simple Reddit Dialogue Preprocessor
                </a>
              </h3>
              </div>
            </li>
            <li>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span className="bishal-santra-post-meta">Jul 3, 2019</span>
              <h3>
                <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2019/07/03/how-i-made-this-site.html">
                  How I created this site using Jekyll?
                </a>
              </h3>
              </div>
            </li>
            <li>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span className="bishal-santra-post-meta">Jan 12, 2017</span>
              <h3>
                <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2017/01/12/generating-gamma-rv-cuda.html">
                  Generating Gamma Random Variable in CUDA in Parallel
                </a>
              </h3>
              </div>
            </li>
            <li>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span className="bishal-santra-post-meta">Aug 6, 2016</span>
              <h3>
                <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2016/08/06/mmse-estimator.html">
                  Minimum Mean Squared Error (MMSE) Estimator
                </a>
              </h3>
              </div>
            </li>
            <li>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span className="bishal-santra-post-meta">Mar 14, 2016</span>
              <h3>
                <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2016/03/14/decycledjson.html">
                  DecycledJSON - Circular reference breakers for JSON
                </a>
              </h3>
              </div>
            </li>
          </ul>
          

          <ul>
          <li>
                        <span className="bishal-santra-post-meta">Aug 6, 2016</span>
                        <h3>
                          <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2016/08/06/mmse-estimator.html">
                            Minimum Mean Squared Error (MMSE) Estimator
                          </a>
                        </h3>
                      </li>
                      <p>Now we verify the performance of MMSE estimator using the following MATLAB Code.</p>
          </ul>
         
        </>
        );
      };
      
export default Bishal_Santra_BlogPosts;
 